import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
// import './style.css'
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import About from "./pages/About";
import BookAppointment from "./pages/BookAppointment";
import Western from "./pages/Western";
import Arabic from "./pages/Arabic";
import Alteration from "./pages/Alteration";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import DeliveryAndShipment from "./pages/DeliveryAndShipment";
import { CartProvider } from "./components/Cart";

function App() {

  
  const [pageTitle, setPageTitle] = useState();

  useEffect(() => {
    
    document.title = pageTitle;
   
  }, [pageTitle]);

  return (
    <CartProvider>
        <Routes>
          <Route
            path="/"
            element={<Home setPageTitle={setPageTitle} />}
          />
          <Route
            path="/shop"
            element={<Shop setPageTitle={setPageTitle} />}
          />
          <Route
            path="/executive-elegance"
            element={<Western setPageTitle={setPageTitle} />}
          />
          <Route
            path="/arabian-ethereals"
            element={<Arabic setPageTitle={setPageTitle} />}
          />
          <Route
            path="/about"
            element={<About setPageTitle={setPageTitle} />}
          />
          <Route
            path="/book-appointment"
            element={<BookAppointment setPageTitle={setPageTitle} />}
          />
          <Route
            path="/alteration"
            element={<Alteration setPageTitle={setPageTitle} />}
          />
          <Route
            path="/product/:id"
            element={<Product setPageTitle={setPageTitle} />}
          />
          <Route
            path="/checkout"
            element={<Checkout setPageTitle={setPageTitle} />}
          />
          <Route
            path="/privacy-policy"
            element={<PrivacyPolicy setPageTitle={setPageTitle} />}
          />
          <Route
            path="/terms-of-service"
            element={<TermsOfService setPageTitle={setPageTitle} />}
          />
          <Route
            path="/refund-policy"
            element={<RefundPolicy setPageTitle={setPageTitle} />}
          />
          <Route
            path="/delivery-and-shipment"
            element={<DeliveryAndShipment setPageTitle={setPageTitle} />}
          />
        </Routes>
        </CartProvider>
  );
}

export default App;
